import { ErrorPageLayout } from '@/components/features/Errors/ErrorPageLayout';
import { Button } from '@/components/ui/shadcn/button';
import { useTranslations } from '@/hooks/useTranslations';
import { Head, Link } from '@inertiajs/react';
import { Home, RotateCw, ServerCrash } from 'lucide-react';

export default function ServerError() {
    const { t } = useTranslations();

    return (
        <>
            <Head title={t('errors.server_error.title', 'Something went wrong')} />
            <ErrorPageLayout
                icon={<ServerCrash />}
                tone="danger"
                code={t('errors.server_error.code', '500')}
                title={t('errors.server_error.title', 'Something went wrong')}
                description={t('errors.server_error.description', 'An unexpected error occurred on our end. Please try again in a moment.')}
                actions={
                    <>
                        <Button variant="outline" asChild>
                            <Link href="/">
                                <Home className="mr-2 h-4 w-4" />
                                {t('errors.server_error.back_home', 'Back to home')}
                            </Link>
                        </Button>
                        <Button onClick={() => window.location.reload()}>
                            <RotateCw className="mr-2 h-4 w-4" />
                            {t('errors.server_error.retry', 'Try again')}
                        </Button>
                    </>
                }
            />
        </>
    );
}
